// Client testimonials — seeded from real client feedback style.
// Update via admin dashboard later, or edit directly here.
export const TESTIMONIALS = [
    {
        id: "t1",
        name: "Marie L.",
        city: "Blainville",
        service: "Massage Signature 90 min",
        rating: 5,
        date: "2026-01-14",
        text: "Jérémy est à l'écoute et professionnel. J'ai découvert une nouvelle approche du massage qui m'a permis de vraiment relâcher les tensions dans le dos. Le cabinet est chaleureux, l'atmosphère est apaisante. Je recommande à 100 %.",
    },
    {
        id: "t2",
        name: "Pierre T.",
        city: "Terrebonne",
        service: "Massage Classique 60 min",
        rating: 5,
        date: "2026-01-22",
        text: "Excellent massage suédois, technique impeccable. Le rapport qualité-prix est très bon. J'y retourne aux 3 semaines pour la détente et je vois une différence dans mon sommeil.",
    },
    {
        id: "t3",
        name: "Sophie D.",
        city: "Sainte-Thérèse",
        service: "Massage Biocorporel 90 min",
        rating: 5,
        date: "2026-02-03",
        text: "Le massage biocorporel a été une révélation. Jérémy prend le temps de comprendre où on en est. Je me suis sentie complètement rebranchée à mon corps après la séance.",
    },
    {
        id: "t4",
        name: "Guillaume B.",
        city: "Mirabel",
        service: "Forfait 6 massages",
        rating: 5,
        date: "2026-02-10",
        text: "J'ai pris le forfait de 6 massages pour gérer mon stress au travail. La différence est nette après 3 séances. Économie intéressante et flexibilité pour prendre les rendez-vous quand je veux.",
    },
    {
        id: "t5",
        name: "Isabelle R.",
        city: "Boisbriand",
        service: "Massage Enrichi 120 min",
        rating: 5,
        date: "2026-02-15",
        text: "2 heures de pure déconnexion. Jérémy est doué et attentionné. La séance enrichie vaut vraiment la peine — j'ai eu droit à un moment complet de soin. Merci !",
    },
    {
        id: "t6",
        name: "Karine F.",
        city: "Rosemère",
        service: "Massage Signature 90 min",
        rating: 5,
        date: "2026-02-19",
        text: "Cabinet propre, ponctuel, chaleureux. Jérémy explique bien les techniques et adapte à ce dont on a besoin. Je repars toujours mieux qu'en arrivant.",
    },
];

export const RATING_STATS = {
    count: TESTIMONIALS.length,
    average: (TESTIMONIALS.reduce((s, t) => s + t.rating, 0) / TESTIMONIALS.length).toFixed(1),
};
